<template>
    <div class="build-task">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
            <!-- <el-breadcrumb-item>活动管理</el-breadcrumb-item> -->
            <el-breadcrumb-item><em style="color: #409EFF;">{{ first_level }}</em></el-breadcrumb-item>
            <el-breadcrumb-item><em style="color: #E6A23C;">{{ second_level }}</em></el-breadcrumb-item>
        </el-breadcrumb>
        <div style="text-align: right;margin-bottom: 0.2rem;display: flex;">
            <!-- <import @imported="imported" :extraData="id"
                data="App\Http\Controllers\Admin\CallTaskController::importBuildTask" multiple>
                <template v-slot:name>
                    <span>选择文件导入</span>
                    <el-tooltip effect="dark" content="点击查看导入模版示例" placement="top">
                        <i @click.stop="showExampleDialog" style="cursor: pointer;color: " class="el-icon-info"></i>
                    </el-tooltip>
                </template>
</import> -->
            <!-- <el-upload action="" :headers="headers" ref="uploadMutiple" multiple :show-file-list="false"
                :http-request="upload">
                <!== <el-tooltip class="item" :effect="effect" :content="tooltip_content"
                    :placement="placement"> ==>
                    <el-button type="primary" size="mini">
                        选择文件导入创建任务
                    </el-button>
                <!== </el-tooltip> ==>
            </el-upload> -->
            <div style="display: flex;flex-direction: row;gap: 0.2rem;margin-left: auto;">
                <div>
                    <input type="file" id="file" ref="fileInput" webkitdirectory directory style="display: none"
                        @change="handleFileChange">
                    <el-button slot="trigger" size="mini" type="primary" @click="handleClick">创建导入任务</el-button>
                </div>
                <!-- <el-button size="mini" type="primary" @click="openUploadTaskDialog">打开任务详情</el-button> -->
            </div>
        </div>

        <div>
            <el-input size="mini" :autosize="{ minRows: 2 }" type="textarea" v-model="copy" placeholder=""
                style="white-space: pre"></el-input>

            <div style="text-align: right;padding: 0.2rem 0;">
                <el-button size="mini" type="primary" @click="handleSubmit()">提
                    交</el-button>
            </div>
        </div>

        <div style="display: flex;margin-top: 0.2rem;flex-direction: column;">
            <div style="text-align: center;" class="dia-title">任务详情</div>
            <call-task-cate-manage-upload-task :cateId="id" style="height: 72vh;overflow-y: auto" />
        </div>

        <el-dialog :visible.sync="dialog_example" @closeDialog="closeDialog_example"
            @beforeCloseDialog="beforeCloseDialog_example" width="50%" center append-to-body>
            <template v-slot:title>
                <span class="cal-tas-m-dia-title">
                    导入模版说明
                </span>
            </template>
            <div v-if="!imgExampleUrl" style="text-align: center">图片加载中...</div>
            <el-image v-else :src="imgExampleUrl" :preview-src-list="[imgExampleUrl]">
            </el-image>
        </el-dialog>

        <el-dialog :visible.sync="dialog_upload_task" @close="closeDialog_upload_task"
            @beforeClose="beforeCloseDialog_upload_task" width="60%" center append-to-body>
            <template v-slot:title>
                <span class="dia-title">
                    任务详情
                </span>
            </template>
            <div class="cal-tas-m-bg-con" v-if="dialog_upload_task">
                <call-task-cate-manage-upload-task />
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Import from '../../../commonReform/Import'
import CallTaskCateManageUploadTask from './CallTaskCateManageUploadTask'
export default {
    name: 'BuildTask',
    components: { Import, CallTaskCateManageUploadTask },
    props: {
        id: {
            type: Number
        },
        first_level: {
            type: String
        },
        second_level: {
            type: String
        }
    },
    watch: {
        id(n) {
            if (n === null) {
                this.copy = ''
                this.taskArr.copy = []
            }
        },
        copy() {
            this.handleCopyChange()
        }
    },
    data() {
        return {
            copy: '',
            taskArr: {
                copy: []
            },
            dialog_example: false,
            imgExampleUrl: '',
            headers: { Authorization: localStorage.token },
            hyperfHost:
                process.env.NODE_ENV === "development"
                    ? "http://127.0.0.1:9501/v1/"
                    : "https://qyh-next-server.zhang66.cn/v1/",
            dialog_upload_task: false
        }
    },
    methods: {
        handleCopyChange() {
            this.taskArr.copy = this.copy.split('\n').map(item => item.trim())
        },
        buildTask() {
            // this.$axios.get('/api/api3_call_task/build_task', {
            this.$axios.get(`${this.hyperfHost}qyh/call-task-manage/create-task-paste`, {
                params: {
                    data: this.taskArr,
                    id: this.id
                }
            }).then(({ data }) => {
                // if (data.code === 0) this.$message.success(data.msg)
                // this.$emit('builded')
                if (data.code === 0) {
                    this.$message.success('任务创建成功!')
                    // this.dialog_upload_task = true
                }
            }).catch()
        },
        handleSubmit() {
            if (!this.taskArr.copy) this.$message.warning('没有填入公司名称!')
            this.buildTask()
        },
        imported(data) {
            if (data.code === 0) {
                this.$message.success(data.msg)
                this.$emit('builded')
            }
        },
        loadImgExample() {
            this.$axios.get('api/api3_call_task/get_example_img_build_task').then(({ data }) => {
                if (data.code === 0) {
                    this.imgExampleUrl = data.url
                }
            }).catch()
        },
        showExampleDialog() {
            this.loadImgExample()
            this.dialog_example = true
        },
        closeDialog_example() {
        },
        beforeCloseDialog_example() {
        },
        upload(file) {
            const formData = new FormData()
            formData.append('file', file.file)
            this.$axios
                // .post(`${this.hyperfHostAuto}qyh/call-task-manage/create-task`,formData)
                .post(`${this.hyperfHostAuto}qyh/call-task-manage/create-task`, formData)
                .then(({ data }) => {
                    // let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                    // let objectUrl = window.URL.createObjectURL(blob)
                    // let link = document.createElement('a')
                    // link.href = objectUrl
                    // link.download = this.excel_date + '顺丰运单不在系统统计.xlsx'
                    // link.click()
                    // setTimeout(function () {
                    //     window.URL.revokeObjectURL(objectUrl)
                    // }, 10)
                })
                .catch()
        },
        handleClick() {
            // document.getElementById('file').click();
            this.$refs.fileInput.click()
        },
        handleFileChange(e) {
            let files = e.target.files;
            // 这里你可以处理你的文件上传逻辑
            let formData = new FormData();
            formData.append('id', this.id);
            for (let i = 0; i < files.length; i++) {
                if (files[i].name === '.DS_Store') continue;
                formData.append('files[]', files[i]);
            }

            this.$axios.post(`${this.hyperfHost}qyh/call-task-manage/create-task`, formData).then(({ data }) => {
                // 处理响应
                if (data.code === 0) {
                    this.$message.success('上传任务创建成功!')
                    // setTimeout(() => {
                    //     this.dialog_upload_task = true
                    // }, 500)
                }
            }).catch(error => {
                // 处理错误
                console.error(error);
            });
        },
        openUploadTaskDialog() {
            this.dialog_upload_task = true
        },
        closeDialog_upload_task() {
        },
        beforeCloseDialog_upload_task() {
        }
    }
}
</script>

<style scoped>
.build-task>>>.el-dialog {
    display: flex;
    flex-direction: column;
    margin: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    /*height:600px;*/
    max-height: calc(100% - 200px);
    max-width: calc(100% - 30px);
    box-shadow: 0 15px 30px rgba(0, 0, 0, .3);
}

.build-task>>>.el-dialog .el-dialog__body {
    flex: 1;
    overflow: auto;
}

.dia-title {
    font-size: large;
    font-weight: bold;
    color: #409EFF;
}

.build-task .cal-tas-m-bg-con {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/pages/cloudClue/Components/BuildTask.vue